export const EntityNameColumnId = 'entityDisplayName';
export const ChangeBarColumnId = 'changeBar';
export const InsightColumnId = 'insight';
